import PhoenixInstall from "../../../../contents/docs/integrate/_snippets/install-phoenix.mdx";
import * as React from 'react';
export default {
  PhoenixInstall,
  React
};